<template>
  <div>
    <div class="vx-row">
      <PaymentExpense v-if="visibleContractFee" :btnQrPayment="btnQrPayment"
                      :type="IQrPaymentType.contractFee"></PaymentExpense>
      <PaymentExpense v-if="visibleTaxAmount" :btnQrPayment="btnQrPayment"
                      :type="IQrPaymentType.taxAmount"></PaymentExpense>
      <PaymentExpense v-if="visibleProcessingFee" :btnQrPayment="btnQrPayment"
                      :type="IQrPaymentType.processingFee"></PaymentExpense>
      <PaymentExpense v-if="visibleCourtOrderExpense" :btnQrPayment="btnQrPayment"
                      :type="IQrPaymentType.courtOrderExpense"></PaymentExpense>
    </div>

    <div class="vx-row" >
      <PaymentOutstanding v-if="visiblePaymentOutstanding" :btnQrPayment="btnQrPayment"></PaymentOutstanding>
      <PaymentNormal v-if="visiblePaymentNormal" :btnQrPayment="btnQrPayment"></PaymentNormal>
      <PaymentClose :btnQrPayment="btnQrPayment"></PaymentClose>
    </div>

    <vs-popup title="ชำระผ่าน QR CODE" :active.sync="paymentPopup">
      <div class="vx-row">
        <div class="vx-col mr-auto ml-auto">
          <div class="vx-row flex" v-if="_qrPayment.paidFee > 0">
            <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidPenalty > 0">
            <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidPenalty | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidInterest > 0">
            <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidInterest | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidPrinciple > 0">
            <span class="vx-col flex-1 text-left label">เงินต้น</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidPrinciple | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidContractFee > 0">
            <span
              class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.contractFee)}` }}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidContractFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidTaxAmount > 0">
            <span
              class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.taxAmount)}` }}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidTaxAmount | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidProcessingFee > 0">
            <span
              class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.processingFee)}` }}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidProcessingFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidCourtOrderExpense > 0">
            <span
              class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.courtOrderExpense)}` }}</span>
            <span class="vx-col flex-1 text-right label-bold">{{
                _qrPayment.paidCourtOrderExpense | numberFormat
              }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.balanceRemain > 0">
            <span class="vx-col flex-1 text-left label">ดอกเบี้ยรับล่วงหน้า</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.balanceRemain | numberFormat }}</span>
          </div>
          <br>
          <br>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ยอดรวม</span>
            <div class="vx-col flex-1 text-right"><span class="money-bold">{{
                _qrPayment.amount | numberFormat
              }} </span> <span class="label-bold">บาท</span></div>
          </div>
          <br>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label-bold">ชำระภายในวันที่ {{ _qrPayment.dueDate }}</span>
          </div>
          <div class="vx-row flex mb-1">
            <div class="mr-auto ml-auto" ref="qrcode"></div>
          </div>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ใช้แอปพลิเคชันธนาคารสแกน QR CODE นี้ เพื่อชำระเงินรองรับทุกธนาคาร โดยไม่มีค่าธรรมเนียม</span>
          </div>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label-link cursor-pointer"><a @click="btnReload()"><u><b>คลิกเพื่ออัพเดตยอด</b></u></a></span>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {IPaymentAmountDetailType, IQrPaymentType} from "@/constants/interface";
import * as QRCode from 'easyqrcodejs'
import {createNamespacedHelpers} from 'vuex'
import {isEmpty} from '@/utils'
import PaymentExpense from "./components/paymentExpense.vue";
import PaymentOutstanding from "./components/paymentOutstanding";
import PaymentNormal from "./components/paymentNormal";
import PaymentClose from "./components/paymentClose";

const {mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting')

export default {
  components: {
    PaymentExpense,
    PaymentOutstanding,
    PaymentNormal,
    PaymentClose,
  },
  data() {
    return {
      qrcode: null,
      qrcodeTxt: "",
      paymentPopup: false,
    }
  },
  async created() {
    const vm = this
    if (isEmpty(vm.contract)) {
      await vm.$router.push("/")
    } else {
      const {getPaymentAmountDetailByContractId, getPaymentRoundDetailByContractId} = vm;
      await getPaymentAmountDetailByContractId({
        form: {
          contractId: vm.contract.id,
          type: IPaymentAmountDetailType.outstanding,
          amount: 0
        }
      });
      await getPaymentAmountDetailByContractId({
        form: {
          contractId: vm.contract.id,
          type: IPaymentAmountDetailType.normal,
          amount: 0
        }
      });
      await getPaymentAmountDetailByContractId({
        form: {
          contractId: vm.contract.id,
          type: IPaymentAmountDetailType.close,
          amount: 0
        }
      });
      await getPaymentRoundDetailByContractId({form: {contractId: vm.contract.id}});
    }
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailNormal', 'paymentAmountDetailOutstanding', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    IQrPaymentType() {
      return IQrPaymentType
    },
    _qrPayment() {
      if (!this.qrPayment) return {}
      return {
        paidFee: this.qrPayment.paidFee,
        paidPenalty: this.qrPayment.paidPenalty,
        paidInterest: this.qrPayment.paidInterest,
        paidPrinciple: this.qrPayment.paidPrinciple,
        paidContractFee: this.qrPayment.paidContractFee,
        paidTaxAmount: this.qrPayment.paidTaxAmount,
        paidProcessingFee: this.qrPayment.paidProcessingFee,
        paidCourtOrderExpense: this.qrPayment.paidCourtOrderExpense,
        balanceRemain: this.qrPayment.balanceRemain,
        dueDate: this.qrPayment.dueDate,
        amount: this.qrPayment.amount,
        createdAt: this.qrPayment.createdAt,
      }
    },
    overDue() {
      return this.contract.loan.isOverDue;
    },
    visibleContractFee() {
      const {contractFeeRemain} = this.loan
      return contractFeeRemain > 0;
    },
    visibleTaxAmount() {
      const {taxAmountRemain} = this.loan
      return taxAmountRemain > 0;
    },
    visibleProcessingFee() {
      const {processingFeeRemain} = this.loan
      return processingFeeRemain > 0;
    },
    visibleCourtOrderExpense() {
      const {courtOrderExpenseRemain} = this.loan
      return courtOrderExpenseRemain > 0;
    },
    visiblePaymentOutstanding() {
      return this.paymentAmountDetailOutstanding.amount >= 1 && !this.overDue
    },
    visiblePaymentNormal() {
      return this.paymentAmountDetailNormal.amount >= 1 && !this.overDue
    },
    dummyInfo() {
      if (!this.$store.state.currentUser) return null
      return this.$store.state.currentUser.dummyInfo
    },
  },
  methods: {
    ...mapAccountingActions([
      'getPaymentAmountDetailByContractId',
      'getPaymentRoundDetailByContractId',
      'getContractsByCurrentUser',
      'createQrPayment'
    ]),
    async btnQrPayment(type, amount) {
      const vm = this
      const {createQrPayment} = vm
      const result = await createQrPayment({
        contractId: vm.contract.id,
        form: {type, amount: parseFloat(amount)}
      })
      const {qrPayment} = vm
      const {taxId, suffix, ref1, ref2, amount: QrAmount} = qrPayment

      if (vm.qrcode) vm.qrcode.clear()
      if (result === true) {
        const cr = '\r'
        const text = '|'
          + taxId
          + suffix + cr
          + ref1 + cr
          + ref2 + cr
          + QrAmount.toFixed(2).replace(/\./g, '')

        const options = {
          text: text,
          width: 256,
          height: 256,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.M,
          // ==== Title
          title: '', // content
          titleFont: "bold 18px Arial", //font. default is "bold 16px Arial"
          titleColor: "#004284", // color. default is "#000"
          titleBgColor: "#fff", // background color. default is "#fff"
          titleHeight: 10, // height, including subTitle. default is 50
          titleTop: 25, // draws y coordinates. default is 30

          // ==== SubTitle
          // subTitle: 'QR subTitle', // content
          // subTitleFont: "14px Arial", // font. default is "14px Arial"
          // subTitleColor: "#004284", // color. default is "gray"
          // subTitleTop: 40, // draws y coordinates. default is 50

          // ==== Logo
          // logo: "../images/qrcodelogo/Thai_QR_Payment_Logo-03.png", // Relative address, relative to easy.qrcode.min.js
          logo: require("@/assets/images/logo/logo-wel-barcode.png"), // Relative address, relative to easy.qrcode.min.js
          // logo:"http://127.0.0.1:8020/easy-qrcodejs/demo/logo.png",
          logoWidth: 40, // widht. default is automatic width
          logoHeight: 40, // height. default is automatic height
          // logoBgColor:'#fffff', // Logo backgroud color, Invalid when logBgTransparent is true; default is '#ffffff'
          logoBgTransparent: true, // Whether use transparent image, default is false
        }
        vm.paymentPopup = true
        vm.qrcode = new QRCode(vm.$refs.qrcode, options);
      } else {
        alert(result.graphQLErrors[0].message)
      }
    },
    btnReload() {
      const vm = this
      const {getContractsByCurrentUser} = vm;
      getContractsByCurrentUser().then(() => {
        vm.paymentPopup = false
        vm.$router.push({name: 'home'})
      })
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
};
</script>
<style>
span.title-head {
  color: #0f4c81;
  font-size: 23px;
  font-weight: 600;
}

span.title-bold {
  color: #000000;
  font-size: 20px;
  font-weight: 600;
}

span.label {
  color: #8389a2;
  font-size: 15px;
  font-weight: 400;
}

span.label-bold {
  color: #000000;
  font-size: 15px;
  font-weight: 600;
}

span.label-link {
  color: #0f4c81;
  font-size: 23px;
  font-weight: 600;
}

span.money-bold {
  color: #0f4c81;
  font-size: 23px;
  font-weight: 600;
}

hr {
  border: 1px solid #8389a2;
}

.con-vs-popup .vs-popup {
  width: 400px !important;
  height: auto !important;
}
</style>

